import React, { createContext, useContext, ReactNode } from 'react';
import useResources from '@root/hooks/useResources';


const defaultState: allAnyTypes = {
  setPageNo: () => {},
  pageCount: 1,
  setPageCount: () => {},
  removeResource: () => {},
  fetchResources: () => {},
  addResource: () => {},
  resourcesLoading: false,
  addResourcesLoading: false,
  deleteResourcesLoading: false,
  resourcesData: [],
};

const ResourcesContext = createContext<allAnyTypes>(defaultState);

interface ResourcesProviderProps {
  children: ReactNode;
}

export const ResourcesProvider: React.FC<ResourcesProviderProps> = ({ children }) => {
  const Resources = useResources();
  return (
    <ResourcesContext.Provider value={Resources}>
      {children}
    </ResourcesContext.Provider>
  );
};

export const useResourcesContext = () => {
  return useContext(ResourcesContext);
};
